<div class="container-box">
  <app-table-header tableTitle="Gestione venditori" (btnUpdateClick)="loadSellers()">
    <app-button-new-seller action-button></app-button-new-seller>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="sellersTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
